import React from 'react';
import styled from 'styled-components';
import SVGRenderer from '../../chunks/SVGRenderer';
import { combineClassNames } from '../../utils/base';
import { ImageComponent as Type } from '../../types/base';
import generateComponentStyles from '../../utils/styleHelper';

const StyledImage = styled.img<{
  $shape?: any;
  $parentDisplay?: string;
  $parentFlexDirection?: string;
}>`
 z-index: 1;
  ${(props) => generateComponentStyles(props.$shape, undefined, undefined, props.$parentDisplay, undefined, props.$parentFlexDirection)}
`;

const StyledDiv = styled.div<{
  $shape?: any;
  $parentDisplay?: string;
  $parentFlexDirection?: string;
}>`
  ${(props) => generateComponentStyles(props.$shape, undefined, undefined, props.$parentDisplay, undefined, props.$parentFlexDirection)}
`;

const Image: React.FC<Type & { parentStyle?: any }> = ({
  id, image, style, svg_string, parentStyle,
}) => {
  // if (image && image.startsWith('$')) {
  //   const iconName = image.substring(1);
  //   const SvgComponent = result[iconName];

  //   if (SvgComponent) {
  //     return <SvgComponent />;
  //   } else {
  //     // Handle the case where the SVG component is not found
  //     console.error(`SVG component "${iconName}" not found in result2.`);
  //     return null;
  //   }
  // }

  // If svg_string is provided, render SVGRenderer
  if (svg_string) {
    return (
      <SVGRenderer svg_string={svg_string} />
    );
  }

  // Otherwise, render the StyledImage component
  return (
    <StyledImage
      id={id}
      src={image}
      alt={id}
      $shape={style}
      $parentDisplay={parentStyle?.display}
      $parentFlexDirection={typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined}
      data-component="image"
      className={combineClassNames(style.class)}
    />
  );
};

export default Image;
